"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M6.861 2.677c-2.98 1.476-5.409 2.7-5.39 2.718.023.02.989.502 2.151 1.074l2.11 1.036 5.423-2.775c2.981-1.528 5.424-2.79 5.424-2.803 0-.014-.863-.45-1.913-.961C13.13.21 12.711.028 12.524.009c-.23-.014-.361.047-5.663 2.668ZM13.198 5.733C8.741 8.01 7.79 8.517 7.855 8.559c.042.029 1.106.558 2.362 1.182l2.288 1.125 3.267-1.618c1.795-.89 4.289-2.123 5.54-2.742l2.274-1.125-2.456-1.214c-1.35-.67-2.466-1.214-2.485-1.214-.014.005-2.465 1.252-5.447 2.78ZM.5 12.403c0 5.18.005 5.442.09 5.62.046.104.135.235.196.291.06.052 2.508 1.35 5.433 2.873 2.925 1.529 5.334 2.785 5.358 2.799.018.01.032-2.583.032-5.766v-5.78L9.238 11.27a199.473 199.473 0 0 0-2.415-1.181c-.023-.01-.042.646-.042 1.589 0 1.542-.004 1.612-.098 1.814-.24.492-.928.637-1.34.276C5 13.467 5 13.486 5 11.203l-.005-2.039L2.83 8.1A320.557 320.557 0 0 0 .584 7.003c-.08-.028-.084.249-.084 5.4ZM18.945 9.703l-5.484 2.71-.028 2.104c-.014 1.153-.033 3.75-.038 5.766-.004 2.91.01 3.67.057 3.665.028 0 2.526-1.293 5.54-2.868l5.485-2.87.014-5.615c.004-3.084-.005-5.61-.024-5.606-.023 0-2.503 1.224-5.522 2.714Z"
}), 'DeliveryBox', {
  viewBox: '0 0 24 24'
});

exports.default = _default;